module.exports = __webpack_public_path__ + "img/14.e36300cd.jpg";